export default "__VITE_ASSET__8a494ced__"